import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";


// Utility: strip everything that isn't a digit or letter (for filename matching)
export const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/g, "");

// Try to auto-match a file to an associate by comparing filename
// against associate's CPF/CNPJ digits or normalized name tokens.
export function autoMatch(filename, associados) {
  if (!filename || !associados?.length) return "";
  const raw = (filename || "").toLowerCase();
  const digitsInName = raw.replace(/\D/g, "");
  const normName = normalize(raw);

  // 1) Match by CPF/CNPJ digits contained in filename
  if (digitsInName.length >= 8) {
    for (const a of associados) {
      const d = (a.cpf_cnpj || "").replace(/\D/g, "");
      if (d && digitsInName.includes(d)) return a.id;
    }
  }

  // 2) Match by significant name token (>= 4 chars)
  for (const a of associados) {
    const tokens = (a.name || "")
      .toLowerCase()
      .split(/\s+/)
      .map(normalize)
      .filter((t) => t.length >= 4);
    for (const t of tokens) {
      if (normName.includes(t)) return a.id;
    }
  }
  return "";
}


export const Label = ({ children }) => (
  <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
    {children}
  </label>
);

export function StatusBadge({ status, error, emailStatus }) {
  if (status === "sending") {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-slate-600">
        <Loader2 size={14} className="animate-spin" /> Enviando
      </span>
    );
  }
  if (status === "ok") {
    const sent = emailStatus?.sent || 0;
    const label = sent > 0 ? "Enviado + e-mail" : "Salvo";
    return (
      <span className="inline-flex items-center gap-1 text-xs text-emerald-700">
        <CheckCircle2 size={14} /> {label}
      </span>
    );
  }
  if (status === "error") {
    return (
      <span
        className="inline-flex items-center gap-1 text-xs text-rose-700"
        title={error}
      >
        <AlertCircle size={14} /> Erro
      </span>
    );
  }
  return null;
}
